import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {
  constructor() {}

  transform<T extends Record<string, any>>(items: T[] | null, searchColumns: string[], searchQueries: string[]): T[] {
    if (!items) return [];
    if (!searchQueries) return items;

    return items.filter((item) => {
      return searchColumns.every((column, index) => {
        const query = searchQueries[index];

        if (!query) return true;
        const currentItem = item[column];

        if (column == 'birthDateFrom') {
          return true;
        }
        if (column == 'birthDateTo') {
          if (item['birthDate']) {
            const dateFrom = new Date(searchQueries[index - 1]);
            const dateTo = new Date(query);
            return this.checkBirthDate(new Date(item['birthDate']), dateFrom, dateTo);
          } else {
            return false;
          }
        } else if (column == 'warrantyEnds') {
          if (item['warrantyEnds']) {
            const warrantyEnds = new Date(item['warrantyEnds']);
            const dateTo = new Date(query);
            return this.checkWarrantyEnds(warrantyEnds, dateTo);
          } else {
            return false;
          }
        } else if (column == 'firstName') {
          const fullName = [item['firstName'], item['lastName']].join(' ').trim();
          return fullName.toLowerCase().includes(query.toString().toLowerCase());
        } else if (column == 'projects') {
          if (item[column] && item[column].length > 0) {
            return item[column].find((val: any) => val.project.id === query);
          } else if (query == 'UNKNOWN') {
            return true;
          }
        } else if (column == 'managers') {
          const primary = item['primaryManager'] === query;
          const secondary = Array.isArray(item['secondaryManagers']) && item['secondaryManagers'].includes(query);
          return primary || secondary;
        } else if (column == 'device_type') {
          if (item['type']) {
            return item['type'].id == query;
          } else if (query == 'UNKNOWN') {
            return true;
          }
        } else if (column == 'status' || column == 'availability') {
          if (item[column]) {
            return item[column].id == query || item[column].systemId == query;
          } else if (query == 'UNKNOWN') {
            return true;
          }
        } else if (column == 'titles') {
          if (item[column] && item[column].length > 0) {
            return item[column].find((val: any) => val.id === query);
          } else if (query == 'UNKNOWN') {
            return true;
          }
        } else {
          if (!currentItem) return false;

          if (Array.isArray(currentItem)) {
            return item[column].includes(query);
          } else {
            const value = item[column];
            if (typeof value === 'number') {
              return value.toString() === query.toString();
            } else {
              return value.toLowerCase().includes(query.toString().toLowerCase());
            }
          }
        }
      });
    });
  }

  checkBirthDate(userBirthDate: Date, dateFrom: Date, dateTo: Date) {
    const userYear = dateTo.getFullYear();
    const birthDateWithCurrentYear = new Date(Date.UTC(userYear, userBirthDate.getMonth(), userBirthDate.getDate()));
    return birthDateWithCurrentYear.getTime() >= dateFrom.getTime() && birthDateWithCurrentYear.getTime() <= dateTo.getTime();
  }

  checkWarrantyEnds(warrantyEnds: Date, dateTo: Date) {
    return warrantyEnds.getTime() <= dateTo.getTime();
  }
}
